<div class="popup-dialog">
    <div
        class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none"
    >
        <!-- Header -->
        <div
            class="trezo-card-header d-flex align-items-center justify-content-between"
        >
            <div class="trezo-card-title">
                <h5 class="mb-0" *ngIf="order">Order #{{ order.orderNo }}</h5>
                <h5 class="mb-0" *ngIf="!order && !isLoading">Order Details</h5>
            </div>
            <div class="trezo-card-subtitle">
                <button
                    (click)="close()"
                    class="p-0 border-0 lh-1 bg-transparent transition"
                >
                    <i class="ri-close-fill"></i>
                </button>
            </div>
        </div>

        <!-- Loading -->
        <div class="trezo-card-content" *ngIf="isLoading">
            <div class="d-flex align-items-center justify-content-center py-5">
                <div
                    class="spinner-border text-primary"
                    aria-label="Loading order details..."
                ></div>
            </div>
        </div>

        <!-- Three-column layout -->
        <div class="" *ngIf="!isLoading && order">
            <div class="row">
                <!-- ── COL 1: Order info + items ──────────────────────── -->
                <div class="col-md-5 detail-col detail-col--info">
                    <!-- Current Status -->
                    <div class="detail-section">
                        <span class="main-label">Current Status</span>
                        <span [class]="getStatusClass(order.orderStatus)">
                            {{ getStatusLabel(order.orderStatus) }}
                        </span>
                    </div>

                    <!-- Order Meta -->
                    <div class="detail-section">
                        <div class="row g-2">
                            <div class="col-6">
                                <span class="main-label">B2C Tenant</span>
                                <span class="text-body">{{ order.tenantName || "N/A" }}</span>
                            </div>
                            <div class="col-6">
                                <span class="main-label">Ordered By</span>
                                <span class="text-body small">{{ order.userEmail || "N/A" }}</span>
                            </div>
                            <div class="col-4">
                                <span class="main-label">Total Qty</span>
                                <span class="text-body">{{ order.totalQty ?? 0 }}</span>
                            </div>
                            <div class="col-4">
                                <span class="main-label">Total Weight</span>
                                <span class="text-body">{{ order.totalWeight ?? 0 }}</span>
                            </div>
                            <div class="col-4">
                                <span class="main-label">Ordered On</span>
                                <span class="text-body">{{ order.createdOn | date: "dd MMM yyyy" }}</span>
                            </div>
                            <div class="col-12" *ngIf="order.orderNote">
                                <span class="main-label">Order Note</span>
                                <span class="text-body fst-italic">{{ order.orderNote }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Order Items -->
                    <div class="detail-section" *ngIf="order.orderItems.length">
                        <span class="main-label mb-2">
                            Order Items
                            <span class="badge bg-light text-secondary ms-1 fw-normal">{{ order.orderItems.length }}</span>
                        </span>

                        <!-- Global rate input (auto-fills per-item on input) — only when OrderPlaced -->
                        <div *ngIf="isOrderPlaced" class="global-rate-row mb-2">
                            <div class="input-group input-group-sm">
                                <span class="input-group-text rate-prefix">
                                    <i class="ri-price-tag-3-line me-1"></i> ₹/kg (all items)
                                </span>
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Type rate to apply to all items"
                                    [formControl]="globalRateControl"
                                    (input)="onGlobalRateInput()"
                                    min="0"
                                    step="0.01"
                                />
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-sm table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Die / Profile</th>
                                        <th class="text-center">Qty</th>
                                        <th class="text-center">Wt.</th>
                                        <th class="text-end rate-col-header">Rate (₹/kg)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of order.orderItems; let i = index">
                                        <td class="text-muted">{{ i + 1 }}</td>
                                        <td>
                                            <span class="fw-medium d-block">{{ item.dieName }}</span>
                                            <span class="text-muted small">
                                               Die: {{ item.dieNo }}
                                                <ng-container *ngIf="item.categoryName"> &bull; {{ item.categoryName }}</ng-container>
                                            </span>
                                            <span class="text-muted small d-block" *ngIf="item.length">
                                                Sec: {{ item.sectionNo }}
                                            <ng-container *ngIf="item.sectionNo"> &bull; {{ item.length }} {{ item.lengthUnit }}</ng-container>
                                            </span>
                                        </td>
                                        <td class="text-center">{{ item.qty ?? "—" }}</td>
                                        <td class="text-center">{{ item.weight ?? "—" }}</td>
                                        <td class="text-end rate-col">
                                            <input
                                                *ngIf="isOrderPlaced"
                                                type="number"
                                                class="form-control form-control-sm rate-input"
                                                placeholder="0.00"
                                                [formControl]="getRateControl(item.orderItemId)"
                                                min="0"
                                                step="0.01"
                                            />
                                            <span *ngIf="!isOrderPlaced && item.rate" class="text-success fw-semibold small">
                                                ₹{{ item.rate | number: "1.2-2" }}
                                            </span>
                                            <span *ngIf="!isOrderPlaced && !item.rate" class="text-muted small">—</span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="table-light fw-semibold">
                                        <td colspan="2" class="text-end">Total</td>
                                        <td class="text-center">{{ order.totalQty ?? 0 }}</td>
                                        <td class="text-center">{{ order.totalWeight ?? 0 }}</td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <!-- Close button -->
                    <div class="mt-3">
                        <button
                            type="button"
                            (click)="close()"
                            class="warn d-inline-block fw-medium border-0 border-radius transition"
                        >
                            Close
                        </button>
                    </div>
                </div>

                <!-- ── COL 2: Update Status + Payment Terms ───────────── -->
                <div class="col-md-4 detail-col detail-col--actions">
                    <div class="detail-col-inner h-100 d-flex flex-column" [formGroup]="statusForm">

                        <span class="main-label col-section-title mb-3">Update Status</span>

                        <!-- No transitions -->
                        <div *ngIf="allowedStatuses.length === 0" class="no-transition-note">
                            <i class="material-symbols-outlined">lock</i>
                            <span>No further status changes available for this order.</span>
                        </div>

                        <!-- Status dropdown -->
                        <div class="form-group mb-3" *ngIf="allowedStatuses.length > 0">
                            <label for="newStatusSelect" class="main-label">
                                New Status <span class="text-danger">*</span>
                            </label>
                            <select
                                id="newStatusSelect"
                                class="form-select"
                                formControlName="newStatus"
                            >
                                <option [ngValue]="null" disabled>— Select new status —</option>
                                <option *ngFor="let s of allowedStatuses" [value]="s.value">
                                    {{ s.label }}
                                </option>
                            </select>
                        </div>

                        <!-- Remark -->
                        <div class="form-group mb-2 flex-grow-1">
                            <label for="remarkTextarea" class="main-label">Remark / Comment</label>
                            <textarea
                                id="remarkTextarea"
                                class="form-control remark-textarea"
                                rows="5"
                                formControlName="remark"
                                placeholder="Add a remark or comment (optional)..."
                                maxlength="500"
                            ></textarea>
                            <div class="form-text text-muted text-end small">
                                {{ statusForm.get("remark")?.value?.length ?? 0 }}/500
                            </div>
                            <!-- Payment Terms as bullet points below textarea -->
                            <div *ngIf="paymentTerms.length > 0" class="payment-terms-hint mt-1">
                                <span class="payment-terms-hint-label">Payment Terms:</span>
                                <span *ngFor="let term of paymentTerms" class="payment-terms-hint-item">
                                    <i class="ri-circle-fill"></i>{{ term }}
                                </span>
                            </div>
                        </div>

                        <!-- Save button -->
                        <div class="mt-auto" *ngIf="allowedStatuses.length > 0">
                            <button
                                type="button"
                                class="primary w-100 d-block fw-medium border-0 border-radius transition text-center"
                                [disabled]="statusForm.get('newStatus')!.invalid || isSaving"
                                (click)="submitStatusUpdate()"
                            >
                                <span class="position-relative d-inline-flex align-items-center gap-1">
                                    <ng-container *ngIf="isSaving">
                                        <span class="spinner-border spinner-border-sm" role="status"></span>
                                        Saving…
                                    </ng-container>
                                    <ng-container *ngIf="!isSaving">
                                        <i class="material-symbols-outlined">sync</i>
                                        Save Status
                                    </ng-container>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- ── COL 3: Status History ───────────────────────────── -->
                <div class="col-md-3 detail-col detail-col--history">
                    <span class="main-label col-section-title mb-3">
                        Status History
                        <span class="badge bg-secondary ms-1 fw-normal">{{ order.statusHistories.length }}</span>
                    </span>

                    <p *ngIf="!order.statusHistories.length" class="text-muted small mb-0">
                        No status changes recorded yet.
                    </p>

                    <ul *ngIf="order.statusHistories.length" class="list-unstyled order-timeline mb-0">
                        <li *ngFor="let h of order.statusHistories" class="order-timeline-item">
                            <span [class]="getStatusClass(h.status)">{{ getStatusLabel(h.status) }}</span>
                            <p class="mb-0 mt-1 small text-muted">{{ h.changedOn | date: "dd MMM yyyy, HH:mm" }}</p>
                            <p class="mb-0 small text-muted" *ngIf="h.changedByUserName">{{ h.changedByUserName }}</p>
                            <p class="mb-0 mt-1 small remark-text" *ngIf="h.remark">"{{ h.remark }}"</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
